export const DISALLOWED_UPLOAD_EXTENSIONS: ReadonlySet<string> = new Set([
  ".exe",
  ".msi",
  ".msu",
  ".msp",
  ".mst",
  ".com",
  ".scr",
  ".cpl",
  ".drv",
  ".ocx",
  ".efi",
  ".app",
  ".dmg",
  ".pkg",
  ".mpkg",
  ".deb",
  ".rpm",
  ".appimage",
  ".snap",
  ".apk",
  ".ipa",
  ".aab",
  ".xap",
  ".dll",
  ".sys",
  ".so",
  ".dylib",
  ".ko",
  ".o",
  ".jar",
  ".class",
  ".war",
  ".ear",
  ".sh",
  ".bash",
  ".zsh",
  ".fish",
  ".csh",
  ".ksh",
  ".ash",
  ".command",
  ".bat",
  ".cmd",
  ".ps1",
  ".ps2",
  ".psm1",
  ".psd1",
  ".ps1xml",
  ".vbs",
  ".vbe",
  ".vb",
  ".wsf",
  ".wsh",
  ".ws",
  ".hta",
  ".lnk",
  ".url",
  ".scf",
  ".inf",
  ".reg",
  ".jse",
  ".js",
  ".mjs",
  ".cjs",
  ".py",
  ".pyc",
  ".pyo",
  ".pyw",
  ".rb",
  ".pl",
  ".php",
  ".phtml",
  ".jsp",
  ".jspx",
  ".asp",
  ".aspx",
  ".ashx",
  ".cgi",
]);

function getFileExtension(fileName: string): string {
  const lastDot = fileName.lastIndexOf(".");
  if (lastDot < 0) return "";
  return fileName.slice(lastDot).toLowerCase();
}

export function getBlockedExtension(fileName: string): string | null {
  const ext = getFileExtension(fileName);
  if (!ext) return null;
  return DISALLOWED_UPLOAD_EXTENSIONS.has(ext) ? ext : null;
}

export function isUploadAllowed(fileName: string): boolean {
  return getBlockedExtension(fileName) === null;
}
